import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    metaInfo: {}
  },
  getters: {
  },
  mutations: {
    CAHNGE_META_INFO(state, metaInfo) { 
      state.metaInfo = metaInfo;
    }
  },
  actions: {
  },
  modules: {
  }
})
